<template>
    <div cols="12" md="6">
        <v-row>

            <!-- los 2 paneles superiores -->
            <v-col cols="12" class="d-flex justify-space-around">
				<v-card outlined>
					<v-card-text>
						<div ref="top-tooltip">
							<div class="d-flex justify-start">
								Preguntas correctas: {{ indicadores.preCorrectas }}
							</div>
							<div class="d-flex justify-start">
								Preguntas incorrrectas: {{ indicadores.totalPreguntas - indicadores.preCorrectas }}
							</div>
							<div class="d-flex justify-start">
								Total de preguntas: {{ indicadores.totalPreguntas }}
							</div>
						</div>
					</v-card-text>
				</v-card>
				<!-- separation -->
				<v-card outlined>
					<v-card-text>
						<div ref="top-tooltip">
							<div class="d-flex justify-center">
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-badge class="primary--text" icon="fas fa-info">
											<v-btn color="primary" small text v-on="on" v-bind="attrs">
												{{ indicadores.titulo }}
											</v-btn>
										</v-badge>
									</template>
									<span>Promedio general de todas las pruebas del estudiante</span>
								</v-tooltip>
							</div>

							<div class="d-flex justify-center text-h4 font-weight-bold">{{
								(indicadores.promedioPorRangoFecha) }}</div>
						</div>
					</v-card-text>
				</v-card>
			</v-col>


            <!-- métrica -->
            <v-col >
                <v-card outlined>
                    <v-card-title class="d-flex justify-center text-subtitle-2 primary--text">
                        Métrica por evaluaciones
                    </v-card-title>
                    <v-card-text>
                        <div id="chart">
                            <apexchart type="area" height="350" :options="chartOptions2" :series="series2">
                            </apexchart>
                        </div>
                        <div>
                            <v-container>
                                <v-btn-toggle v-model="selectedToggle">
                                <!-- <v-btn value="day">Día</v-btn> -->
                                <v-btn value="semana">Semana</v-btn>
                                <v-btn value="mes">Mes</v-btn>
                                <v-btn value="periodo">Periodo</v-btn>
                                <v-btn value="año">Año</v-btn>
                                </v-btn-toggle>
                            </v-container>
                        </div>

                    </v-card-text>
                    <v-card-subtitle class="d-flex text-center">
                        El siguiente gráfico representa el progreso del estudiante y cómo eso influye en su ranking dentro de la sección. Además, es un gráfico interactivo donde se puede visualizar cualquier punto de interés y ver las preguntas y respuesas.
                    </v-card-subtitle>
                    <v-card-subtitle class="d-flex text-center">
                        EJE VERTICAL: Representación de las notas en formato Literal
                        EJE HORIZONTAL: Muestra las fechas en las que se realizó cada evaluación
                    </v-card-subtitle>
                </v-card>

            </v-col>
        </v-row>

        <!-- VISOR DE RESPUESTAS -->
        <v-dialog v-model="dialogResultados" scrollable max-width="600px">
			<v-card>
				<v-card-title class="modal_title">
					<v-icon dark left>fas fa-layer-group</v-icon>
					MIS RESULTADOS
					<v-spacer></v-spacer>
					<v-tooltip bottom color="#1b1b1b">
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" fab dark x-small class="btn_style4 mr-1" @click="verRptas = !verRptas">
								<v-icon>fa-eye</v-icon>
							</v-btn>
						</template>
						<span>{{ verRptas ? 'Ver mis respuestas' : 'Ver respuestas correctas' }}</span>
					</v-tooltip>
					<v-btn fab dark x-small class="btn_style3" @click="dialogResultados = false">
						<v-icon dark>fa-times</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text >
                    <v-row>
                        <v-col cols="12" >
                            <div v-if="misRespuestasResultados.length == 0" class="d-flex justify-center align-center text-h5" style="height: 500px;">
                                La evaluación no tiene preguntas
                            </div>
                            <v-expansion-panels v-else v-model="panels" multiple>
                                <!-- <v-icon color="error"> mdi-alert-circle </v-icon> -->
        
                                <v-expansion-panel v-for="(Misrespuestas, index) in misRespuestasResultados"
                                    :key="Misrespuestas.id_banco_pregunta">
        
                                    <v-expansion-panel-header disable-icon-rotate class="pb-0">
                                        <div>
                                            <li style="margin-left: 15px" v-html="'<strong class=claseforzada>' +
                                                (index + 1) +
                                                ')</strong><br/>' +
                                                Misrespuestas.pregunta
                                                "></li>
                                        </div>
                                        <template v-slot:actions>
                                            <v-icon right size="30" :color="Misrespuestas.respuesta_correcta_bool ? 'teal' : 'red'">
                                                {{
                                                    Misrespuestas.respuesta_correcta_bool ? "fas fa-check " : "fas fa-times "
                                                }}
                                            </v-icon>
                                        </template>
                                    </v-expansion-panel-header>
                                    <div v-if="!Misrespuestas.respuesta_correcta_bool" class="d-flex pb-4 mx-10">
                                        <!-- LINK PARA ENVIAR A SU CLASE -->
        
                                        <!-- <a style="color:red;" @click="verClase(Misrespuestas.idtema)"
                                            class="text-decoration-none">
                                            <v-icon color="error" small left>fas
                                                fa-book-open</v-icon>
                                            <div style="font-weight:bold;display: inline;">Ir a repasar
                                                unidad :</div> {{ Misrespuestas.nombre_clase }}
                                        </a> -->
                                    </div>
                                    <v-divider></v-divider>
                                    <v-expansion-panel-content>
                                        <v-list shaped>
                                            <v-list-item-group color="primary" active-class="border-in">
                                                <v-subheader class="d-flex justify-space-between">
                                                    <strong>
                                                        <v-icon>far fa-question-circle</v-icon>
                                                        {{ verRptas ? 'Respuestas correctas:' : 'Mis respuestas:' }}
                                                    </strong>
                                                    <small class="pa-5"> <i> {{
                                                        Misrespuestas.id_tipo_pregunta == 'PM'
                                                            ? 'Respuesta múltiple'
                                                            : Misrespuestas.id_tipo_pregunta == 'PU'
                                                                ? 'Respuesta única'
                                                                : 'Respuesta verdadero - falso'
                                                    }} </i> </small>
                                                </v-subheader>
                                                <template v-if="verRptas">
                                                    <v-list-item v-for="nestedRespuestas in Misrespuestas.respuesta"
                                                        :key="nestedRespuestas.id">
                                                        <v-list-item-icon>
                                                            <v-icon :color="nestedRespuestas.respuesta_correcta_boolean ? 'green' : 'red'"
                                                                dark>
                                                                {{ nestedRespuestas.respuesta_correcta_boolean ? "fas fa-check" :
                                                                    "fas fa-times" }}
                                                            </v-icon>
                                                        </v-list-item-icon>
        
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                <li v-html="nestedRespuestas.respuesta"></li>
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
        
                                                </template>
        
                                                <template v-else>
                                                    <v-list-item v-for="nestedRespuestas in Misrespuestas.respuesta"
                                                        :key="nestedRespuestas.id">
                                                        <v-list-item-icon>
                                                            <v-icon :color="nestedRespuestas.respuesta_marcada_por_alumno_bool ? 'green' : 'red'
                                                                " dark>{{
                                                                    nestedRespuestas.respuesta_marcada_por_alumno_bool
                                                                        ? "fas fa-check"
                                                                : "fas fa-times"
                                                                }}</v-icon>
                                                        </v-list-item-icon>
        
                                                        <v-list-item-content>
                                                            <v-list-item-title
                                                                :class="nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false && nestedRespuestas.respuesta_correcta == true ? 'cruz' : ''">
                                                                {{ nestedRespuestas.respuesta }}
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-tooltip left color="error" v-if="(nestedRespuestas.respuesta_correcta == false && Misrespuestas.valor_pregunta == false &&
                                                                nestedRespuestas.valor_respuesta_marcada == true) || (nestedRespuestas.valor_respuesta == true && Misrespuestas.valor_pregunta == false &&
                                                                    nestedRespuestas.valor_respuesta_marcada == false && Misrespuestas.tipo_pregunta ==
                                                                    'res_mul')">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn icon color="error" dark v-bind="attrs" v-on="on">
                                                                        <v-icon color="error">mdi-information</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span> {{
                                                                    nestedRespuestas.valor_respuesta == false &&
                                                                        Misrespuestas.valor_pregunta == false &&
                                                                        nestedRespuestas.valor_respuesta_marcada == true
                                                                        ? "Respuesta Incorrecta"
                                                                        : nestedRespuestas.valor_respuesta == true &&
                                                                            Misrespuestas.valor_pregunta == false &&
                                                                            nestedRespuestas.valor_respuesta_marcada == false &&
                                                                            Misrespuestas.tipo_pregunta ==
                                                                            'res_mul' ? "Faltó marcar esta respuesta" : ""
                                                                }}</span>
                                                            </v-tooltip>
                                                        </v-list-item-action>
                                                    </v-list-item>
                                                </template>
        
                                            </v-list-item-group>
                                        </v-list>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<b>CALIFICACIÓN:</b>
					<v-chip class="ma-2" :color="resultadoVerExamen == 'APROBADO'
						? 'green accent-4'
						: 'red accent-4'
						" text-color="white">
						<v-avatar left :class="resultadoVerExamen == 'APROBADO' ? 'green darken-4' : 'red'
							">
							{{ notaPeru }}
						</v-avatar>
						{{ resultadoVerExamen }}
					</v-chip>
				</v-card-actions>
			</v-card>
		</v-dialog>
    </div>
</template>

<script>
import axios from "@/helpers/axios";
import VueApexCharts from 'vue-apexcharts'
import { CurvadaprendizajeHeaders } from "../../../../helpers/headersTable";
// import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import moment from "moment";

export default {

    props: ['filter', 'change'],
    components: {
        apexchart: VueApexCharts,
        // ComundataTablecomp
    },
    data(){
        return {
            // modificadores de interfaz
            CurvadaprendizajeHeaders,
            notaLiteral: "",
            Evaluaciones: [],
            Areas: [],
            Notas: [],
            dataCurva: [],
            AreasCurva: [],
            AreasSeleccionadas: [],
            // VISOR DE RESPUESTAS
            verRptas: false,
            dialogResultados: false,
            misRespuestasResultados: [],
            panels: [0, 1, 2, 3, 4],
            resultadoVerExamen: null,
            notaPeru: null,

            indicadores: {
                titulo: "PROMEDIO DE NOTAS",
                promedioPorRangoFecha: null,
                preCorrectas: null,
                preIncorrectas: null,
                totalPreguntas: null
            },
            selectedToggle: "año",
    
    
    
    
            series2: [],
            chartOptions2: {
                markers: {
                    size: 4,
                    opacity: 1, // Opacidad de los marcadores. 1 significa completamente opaco.
                    colors: undefined, // Color de los marcadores. Puedes definir colores específicos o dejarlo undefined para usar los predeterminados.
                    strokeColor: "#fff", // Color del borde de los marcadores.
                    strokeWidth: 2,
                    hover: {
                        size: 6, // Tamaño de los marcadores al hacer hover.
                        sizeOffset: 3 // El valor por el cual incrementar el tamaño del marcador al hacer hover.
                    }
                },
                chart: {
                    height: 350,
                    type: 'line',
                    events: {
                        dataPointSelection: (event, chartContext, config) => {

                            const seriesIndex = config.seriesIndex;
                            const dataPointIndex = config.dataPointIndex;
                            const valueY = this.series2[seriesIndex].data[dataPointIndex];

                            //averiguar el valor de id_evaluacion
                            const objEval = this.chartOptions2.xaxis.categories.find(ca => ca.x == valueY.x)
                            this.verResultadosEvaluacion(objEval);
                        }
                    },
                },
    
                row: {
                    colors: undefined,
                    opacity: 0.5
                },
                column: {
                    colors: undefined,
                    opacity: 0.5
                },
    
                xaxis: {
                    type: 'datetime',
                    categories: [],
                    lines: {
                        show: true
                    }
                },
    
                yaxis: {
    
    
                    labels: {
                        formatter: (val) => {
                            if(val == 4){
                                return "AD"
                            } else if (val == 3){
                                return "A"
                            } else if (val == 2){
                                return "B"
                            } else if (val == 1){
                                return "C"
                            }
                            // return val
                        },
                        offsetX: -11,
                        offsetY: 0,
                    },
                    min: 1,
                    max: 4,
                    forceNiceScale: false,
                    tickAmount: 3
                },
    
                grid: {
                    show: true,
                    borderColor: '#90A4AE',
                    strokeDashArray: 0,
                    position: 'back',
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },
                    row: {
                        colors: undefined,
                        opacity: 0.5
                    },
                    column: {
                        colors: undefined,
                        opacity: 0.5
                    },
                    padding: {
                        top: 0,
                        right: 20,
                        bottom: 0,
                        left: 0
                    },
                },
    
                dataLabels: {
                    enabled: false
                },
    
                tooltip: {
                    x: {
                        format: 'dd/MM/yy HH:mm'
                    },
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {

                                if(y > 3 && y <= 4) return "AD"
                                else if (y > 2 && y <= 3) return "A"
                                else if (y > 1 && y <= 2) return "B"
                                else if (y <= 1) return "C"
                                else return "-"
                                // return this.notaLiteralFormater(y);
                            }
                            return y;
                        }
                    },
                    intersect: true,
                    shared: false
                },
            }
    
        }
    },


    methods: {

        formatFec(fecha) {
            return moment(fecha).format("DD/MM/YYYY");
        },

        async fetchDataFromAPI() {
            console.log("se actualiza métricasevaluaciones");
            console.log("%c¡Detente!",  'color: red; font-size: 500%; font-weight: 900;');
            console.log('%cEsta función del navegador está pensada para desarrolladores. Si alguien te indicó que copiaras y pegaras algo aquí para habilitar una función de Inteligenio o para "hackear" la cuenta de alguien, se trata de un fraude. Si lo haces, esta persona podrá acceder a tu cuenta.', 'font-style: oblique; font-size: large;');
            const idCurrentPeriodo = sessionStorage.periodos_actuales.split(",")[0]
            const response = await axios.get("/metricasEvaluaciones", {
                params: {
                    id_alumno: this.filter.id_alumno,
                    range: this.selectedToggle,
                    id_period: idCurrentPeriodo
                }
            });
            this.Evaluaciones = response.data.data;


            let rightAnswered = 0;
            let incorrectas = 0;
            let sumaNotas = 0;
            this.Evaluaciones.forEach(res => {
                if(res.nota_alumno > 1) rightAnswered += 1
                else incorrectas += 1
                sumaNotas += Number(res.nota_alumno);
            })

            this.indicadores.preCorrectas = rightAnswered;
            this.indicadores.preIncorrectas = incorrectas;
            this.indicadores.totalPreguntas = rightAnswered + incorrectas;

            
            this.indicadores.promedioPorRangoFecha = this.notaLiteralFormater(sumaNotas/this.indicadores.totalPreguntas);
            

            this.processData(this.Evaluaciones)
        },


        processData(dataArray) {
            const seriesData = dataArray.map(item => {
                return {
                    // x: new Date(item.fecha).getTime(),
                    x: new Date(`${item.fecha} ${item.hora_inicio}`).getTime(),
                    y: parseFloat(item.nota_real),
                    id_evaluacion: item.id_prog_eval
                };
            });

            seriesData.sort((a, b) => a.x - b.x);


            this.chartOptions2 = {
                    ...this.chartOptions2,
                    xaxis: {
                        ...this.chartOptions2.xaxis,
                        categories: seriesData
                    }
                };

            this.series2 = [{
                    name: 'Evaluaciones',
                    data: seriesData
                }];

        
        },


        async verResultadosEvaluacion(obj_Eval){
            const me = this;
            try {
                const response = await axios.get("/metricasEvaluaciones/allEvaluacionesAlumno", {
                    params: {
                        id_evaluacion: obj_Eval.id_evaluacion,
                        id_alumno: this.filter.id_alumno
                    }
                })

                
                me.misRespuestasResultados = response.data;

                const correctas = me.misRespuestasResultados.filter(re => re.respuesta_correcta_bool)

                //CÁLCULO DE PROMEDIO DE NOTA EN MODAL
                const notaNum = (correctas.length / me.misRespuestasResultados.length) * 4;


                this.notaPeru = this.notaLiteralFormater(notaNum)
                // if(notaNum > 3 && notaNum <= 4) this.notaPeru = "AD"
                // else if (notaNum > 2 && notaNum <= 3) this.notaPeru = "A"
                // else if (notaNum > 1 && notaNum <= 2) this.notaPeru = "B"
                // else if (notaNum <= 1) this.notaPeru = "C"



                me.dialogResultados = true;
            } catch (error) {
                console.error(error);
            }
        },

        notaLiteralFormater(nota){
            if(nota > 3 && nota <= 4) return "AD"
            else if (nota > 2 && nota <= 3) return "A"
            else if (nota > 1 && nota <= 2) return "B"
            else if (nota <= 1) return "C"
            else return "-"
        },

    },
    
    watch: {
        change(){
            this.fetchDataFromAPI();
        },
        selectedToggle(){
            this.fetchDataFromAPI();
        }
    },

    mounted() {
        // this.fetchDataGada()
        this.fetchDataFromAPI()
    },




}
</script>
